/** Strip leading @ — BFF stores lowercase host only. */
export function toPartnerApiDomain(raw: string): string {
	return raw.trim().toLowerCase().replace(/^@+/, "");
}

export function displayPartnerDomain(domain: string): string {
	const host = toPartnerApiDomain(domain);
	return host ? `@${host}` : "";
}

/** @deprecated Prefer {@link toPartnerApiDomain} for API payloads. */
export function normalizePartnerDomain(raw: string): string {
	const host = toPartnerApiDomain(raw);
	return host ? `@${host}` : "";
}
